import React from "react";
import { Progress, Space } from "antd";
import AppLayout from "../layout";
import { BrowserView, MobileOnlyView } from "react-device-detect";
import { CompetencesMobile } from "./mobile";

const Competences = () => {
  return (
    <AppLayout>
      <BrowserView>
        <div className="competences">
          <Space direction="vertical">
            <h1 className="title"> CONNAISSANCE </h1>
            <p className="sub-title">MON NIVEAU DE CONNAISSANCES</p>
          </Space>
          <ProgressCom />
        </div>
      </BrowserView>
      <MobileOnlyView>
        <CompetencesMobile />
      </MobileOnlyView>
    </AppLayout>
  );
};

const ProgressCom = () => {
  return (
    <div className="progress-com">
      <Space direction="horizontal" size={75} wrap>
        {/* <Progress type="circle" percent={75} /> */}
        <OneProgressCom name="HTML & CSS" level={80} />
        <OneProgressCom name="JAVASCRIPT" level={70} />
        <OneProgressCom name="REACT JS" level={70} />
        <OneProgressCom name="REACT NATIVE" level={60} />
        <OneProgressCom name="FIGMA" level={80} />
        <OneProgressCom name="PHOTOSHOP" level={80} />
        <OneProgressCom name="ILLUSTRATOR" level={70} />
      </Space>
    </div>
  );
};

const OneProgressCom = ({ name, level }) => {
  return (
    <div className="one-progress-com">
      <Progress type="circle" percent={level} />
      <h3>{name}</h3>
    </div>
  );
};

// const ProgressCom = () => {
//   return (
//     <div className="ProgressCom">
//       <h1> CONNAISSANCE </h1>
//       <p>MON NIVEAU DE CONNAISSANCES</p>
//       <div className="percent">
//         <label> HTML & CSS </label>
//         <Progress percent={80} />
//       </div>
//       <div className="percent">
//         <label> JAVASCRIPT </label>
//         <Progress percent={60} />
//       </div>{" "}
//       <div className="percent">
//         <label>MYSQL </label>
//         <Progress percent={50} />
//       </div>
//       <div className="percent">
//         <label> REACT JS </label>
//         <Progress percent={80} />
//       </div>
//       <div className="percent">
//         <label> REACT NATIVE </label>
//         <Progress percent={80} />
//       </div>
//       <div className="percent">
//         <label>FIGMA </label>
//         <Progress percent={70} />
//       </div>
//       <div className="percent">
//         <label> PHOTOSHOP </label>
//         <Progress percent={80} />
//       </div>
//       <div className="percent">
//         <label> ILLUSTRATOR </label>
//         <Progress percent={70} />
//       </div>
//     </div>
//   );
// };

export default Competences;
